import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/fornecedorItem'

class FornecedorApiClient {
	async buscarPorFiltro(filtro, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/fornecedorItemProcesso`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(url)
	}
}
export default new FornecedorApiClient()
